module.exports = __webpack_public_path__ + "img/han_site1_2f.42b91522.png";